import React from "react";
import '../../../styles/About.css';
import Tech from "./Tech";
import Experience from "./experience";
import Education from "./education";

const About=()=>{
    return(
        <>
            <div className="About">
                <div className="Tech">
                <Tech/>
                </div>
                <Experience/>
                <Education/>
                </div>
        </>
    )
}

export default About;